import { render, staticRenderFns } from "./AgencyEventRankingStreamerIcon.vue?vue&type=template&id=6320c85a&scoped=true"
import script from "./AgencyEventRankingStreamerIcon.vue?vue&type=script&lang=ts"
export * from "./AgencyEventRankingStreamerIcon.vue?vue&type=script&lang=ts"
import style0 from "./AgencyEventRankingStreamerIcon.vue?vue&type=style&index=0&id=6320c85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320c85a",
  null
  
)

export default component.exports